import React from 'react'

export default function TotalCount(props) {
  return (
    <div>
      <div className="container-fluid my-5 d-flex align-items-center justify-content-center">
          <div className="card shadow-sm p-2">
            <div className="card-body">
               <h6 className='blue-text'>{props.msg}</h6>
               <h4 className='orange-text text-center'>{props.count}{props.isFees && <span> &#8377;</span>}</h4>
            </div>
            </div>
            </div>
    </div>
  )
}
